import { Close } from '@mui/icons-material';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import { EntityState } from '@reduxjs/toolkit';
import { useEffect, useState } from 'react';
import { appStyles } from 'src/theme/styles';

import { Button, ModalContentContainer } from '@/components';
import { LibraryCategoryEntity } from '@/store/categories-api';

import { CategoryTree, SelectedCategoryInfo } from '../../../CategoryTree';

interface CategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedCategoryInfo: SelectedCategoryInfo;
  categories?: EntityState<LibraryCategoryEntity, string>;
  onChange: (selectedCategoryInfo: SelectedCategoryInfo) => void;
}

export const CategoryModal = ({
  isOpen,
  onClose,
  selectedCategoryInfo,
  categories,
  onChange,
}: CategoryModalProps) => {
  const [localSelectedCategoryInfo, setLocalSelectedCategoryInfo] =
    useState<SelectedCategoryInfo>(selectedCategoryInfo);

  useEffect(() => {
    setLocalSelectedCategoryInfo(selectedCategoryInfo);
  }, [selectedCategoryInfo]);
  return (
    <Drawer open={isOpen} onClose={onClose} anchor="bottom">
      <ModalContentContainer stretch>
        <Box
          sx={[
            appStyles.scrollbar,
            {
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              gap: 1,
              height: 'calc(100vh - 110px)',
            },
          ]}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h1">Category</Typography>
            <IconButton onClick={onClose} aria-label="Close modal">
              <Close />
            </IconButton>
          </Box>
          <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
            <CategoryTree
              categories={categories}
              selectedItem={localSelectedCategoryInfo}
              onSelectItem={item => {
                setLocalSelectedCategoryInfo(item);
              }}
            />
          </Box>
          <Box sx={{ mt: 4, display: 'flex', gap: 1 }}>
            <Button
              label="Reset"
              variant="secondary"
              onClick={() => {
                onChange({ categorySlug: null, subCategorySlug: null });
                onClose();
              }}
            />
            <Button
              label="Save"
              disabled={!localSelectedCategoryInfo.categorySlug}
              variant="primary"
              onClick={() => {
                onChange(localSelectedCategoryInfo);
                onClose();
              }}
            />
          </Box>
        </Box>
      </ModalContentContainer>
    </Drawer>
  );
};
